exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ag-ltr .ag-cell.amount,\n.ag-ltr .ag-cell.rate {\n  text-align: right;\n}\n.ag-ltr .ag-cell.editable {\n  background-color: #3ea2ff15;\n}\n\n", ""]);

// exports
